<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="600px">
    <template v-slot:title>Adjust Prices</template>

    <v-row>
      <v-col class="pb-0">
        <v-text-field
          v-model.number="amount"
          :label="isPercent ? 'Percent' : 'Amount'"
          type="number"
          :outlined="outlinedInputs"
          :append-icon="isPercent ? 'mdi-percent' : ''"
        ></v-text-field>
      </v-col>
      <v-col cols="5" class="pb-0" v-if="false">
        <v-radio-group v-model="isPercent" row class="mt-0">
          <v-radio label="Percent Based" :value="true">
            <template v-slot:label>
              <div><v-icon small left>mdi-percent</v-icon>Percent Based</div>
            </template>
          </v-radio>
          <v-radio label="Amount Based" :value="false">
            <template v-slot:label>
              <div>
                <v-icon small left>mdi-currency-usd</v-icon>Amount Based
              </div>
            </template>
          </v-radio>
        </v-radio-group>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="py-0">
        <v-radio-group v-model="isIncrease" row class="mt-0">
          <v-radio label="Increase" :value="true">
            <template v-slot:label>
              <div><v-icon small left>mdi-plus</v-icon>Increase</div>
            </template>
          </v-radio>
          <v-radio label="Decrease" :value="false">
            <template v-slot:label>
              <div><v-icon small left>mdi-minus</v-icon>Decrease</div>
            </template>
          </v-radio>
        </v-radio-group>
      </v-col>
    </v-row>

    <template v-slot:actions>
      <v-btn color="primary" @click="onSave" :disabled="!isValid">Apply</v-btn>
    </template>
  </basic-dialog>
</template>
  
  <script>
import BasicDialog from "../../../shared/BasicDialog.vue";

export default {
  name: "price-adjuster",

  components: {
    BasicDialog,
  },

  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      amount: 0,
      isPercent: true,
      isIncrease: true,
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    isValid() {
      return (
        this.amount !== null &&
        this.amount !== undefined &&
        this.amount !== "" &&
        this.amount !== 0
      );
    },
  },

  methods: {
    onSave() {
      this.$emit("save", {
        amount: this.amount,
        isPercent: this.isPercent,
        isIncrease: this.isIncrease,
      });
      this.$emit("close");
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/tools/PriceAdjuster.vue